import StudioSvg from './StudioSvg';
import WIXSvg from './WIXSvg';

const WixStudioSvg = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: '3.4px',
      }}
    >
      <WIXSvg />
      <StudioSvg />
    </div>
  );
};

export default WixStudioSvg;
